<style scoped lang="less">
.guide-page {
  width: 750px;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.8);
  .guide1 {
    width: 686px;
    height: 460px;
    position: fixed;
    top: 60px;
    left: 60px;
  }
  .guide2 {
    width: 750px;
    height: 534px;
    position: fixed;
    bottom: 0;
    left: 0;
  }
}
.triangle_border_up{
  width:0;
  height:0;
  border-width:0 14px 16px;
  border-style:solid;
  border-color:transparent transparent rgba(35,44,55,0.8);/*透明 透明  灰*/
  position:relative;
  z-index: 9999;
  position: fixed;
  right: 120px;
  top: 1px;
}
.guide-collection{
  position: fixed;
  right: 100px;
  top: 16px;
  width: 414px;
  height: 86px;
  background: #232C37;
  opacity: 0.8;
  z-index: 9999;
  padding: 16px;
  color: #fff;
  line-height: 46px;
  text-align: left;
  font-size:26px;
  border-radius: 15px;
  .collection-img{
    position: absolute;
    top: 18px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
}
.top-search {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: #fff;
  .input-navigate-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-search {
    height: 72px;
    margin-left: 24px;
    font-size: 28px;
    color: #a8a8a8;
    line-height: 74px;
    flex: 1;
    background-repeat: no-repeat;
    background-position: 18px center;
    background-size: 32px;
    background-color: #f3f7fb;
    border-radius: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .search-icon {
    height: 32px;
    width: 32px;
    margin-left: 24px;
    margin-right: 18px;
  }
  .location-img {
    margin-right: 8px;
    margin-left: 8px;
    width: 22px;
    height: 30px;
  }
  .city-arrow {
    margin-left: 14px;
    width: 14px;
    height: 8px;
  }
}

#cityBtn {
  height: 72px;
  line-height: 72px;
  font-size: 30px;
  color: #666;
}
.map-fix-btn {
  width: 84px;
  height: 84px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(85, 85, 85, 0.5);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.map-fix-btn1 {
  width: 68px;
  height: 160px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(85, 85, 85, 0.5);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 99;
  padding: 10px 8px;
}
.map-fix-btn2 {
  width: 68px;
  height: 254px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(85, 85, 85, 0.5);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 99;
  padding: 10px 6px;
}
.map-fix-btn3 {
  width: 370px;
  height: 84px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(85, 85, 85, 0.5);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 99;
}
.map-fix-btn-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid #efefef;
  padding-bottom: 12px;
}
.map-fix-btn-center {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.map-fix-btn-bottom {
  width: 100%;
  border-top: 2px solid #efefef;
  padding-top: 12px;
}
.map-fix-dec {
  font-size: 20px;
  color: rgba(35, 44, 55, 1);
}
.map-fix-words {
  font-size: 30px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: #232c37;
  line-height: 84px;
}
.map-fix-icon {
  height: 40px;
  width: 40px;
}
.screen-position {
  position: fixed;
  right: 16px;
  top: 132px;
}
.location-position {
  position: fixed;
  left: 16px;
  bottom: 176px;
}
.tucao-position {
  position: fixed;
  left: 16px;
  bottom: 148px;
}
.list-position {
  position: fixed;
  right: 16px;
  top: 322px;
}
.close-position {
  position: fixed;
  left: 16px;
  bottom: 18px;
}
.analysis-position {
  position: fixed;
  left: 190px;
  bottom: 18px;
}
.reset-position {
  position: fixed;
  right: 16px;
  bottom: 18px;
}
.map-fix-footer {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.map-fix-footer-content {
  height: 140px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 20px 0px rgba(136, 136, 136, 0.5);
  border-radius: 6px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.map-fix-footer-text {
  width: 246px;
  font-size: 26px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(35, 44, 55, 1);
  margin-left: 10px;
  text-align: left;
}
.map-fix-footer-btn {
  border: none;
  height: 52px;
  line-height: 52px;
  background: rgba(65, 105, 225, 1);
  box-shadow: 0px 6px 10px 0px rgba(65, 105, 225, 0.27);
  border-radius: 4px;
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  margin-right: 16px;
}
.map-fix-footer-img {
  width: 36px;
  height: 32px;
  margin-left: 10px;
}
.map-fix-price-img {
  width: 36px;
  height: 36px;
  margin-left: 10px;
}
#container {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.swiper-slide {
  width: 68.5%;
}
.transition1 {
  .v-enter,
  .v-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  }
}
.transition2 {
  .v-enter,
  .v-leave-to {
    opacity: 0;
    transform: translateY(100px);
  }
}
.v-enter-active,
.v-leave-active {
  transition: all 0.4s ease;
}
#HomeSearchBar {
  color: #bdc3ce;
  height: 32px;
  line-height: 34px;
}
.open-more {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.32);
  z-index: 9999;
  .more-box {
    width: 206px;
    height: 118px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    opacity: 0.96;
    position: absolute;
    top: 322px;
    right: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 36px 40px 26px;
    .more-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .more-fix-btn {
        width: 72px;
        height: 72px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 12px 0px rgba(85, 85, 85, 0.5);
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 14px;
      }
      .more-fix-dec {
        font-size: 22px;
        color: rgba(35, 44, 55, 1);
      }
    }
  }
}
</style>
<template>
  <div id="page">
    <div class="triangle_border_up" v-if="showCollection">
      <span></span>
    </div>
    <div class="guide-collection" v-if="showCollection">
      <div>
        <div>点击“添加到我的小程序”，</div>
        <div>快捷进入会选址</div>
      </div>
      <img class="collection-img" @click.stop="closeCollection" src="../../assets/img/close_guide.png" />
    </div>
    <div class="guide-page" v-if="showGuide" @click="closeGuide">
      <img class="guide1" src="../../assets/img/guide1.png">
      <img class="guide2" src="../../assets/img/guide2.png">
    </div>
    <div id="container" :style="{height:clientHeight}"></div>
    <div class="transition1">
      <transition>
        <div class="top-search" v-if="hiddenLabel&&!isInDrawing&&!openAttentionState">
          <div class="input-navigate-box" v-debounce="goCitySelect">
            <img src="../../assets/img/location.png" class="location-img">
            <div id="cityBtn">{{selectCityName?selectCityName:currentCityName}}</div>
          </div>
          <img src="../../assets/img/city-arrow.png" class="city-arrow">
          <div class="img-search" v-debounce="goSearch">
            <div class="input-navigate-box">
              <img class="search-icon" src="../../assets/img/icon_search_default.png">
              <div id="HomeSearchBar" style="width:100%;">请输入选址目标商圈或小区</div>
            </div>
          </div>
        </div>
      </transition>
      <transition>
        <div
          v-if="hiddenLabel&&!isInDrawing&&!openAttentionState"
          class="map-fix-btn1 screen-position"
        >
          <div class="map-fix-btn-top" v-debounce="screenTradingArea">
            <img class="map-fix-icon" src="../../assets/img/screen.png">
            <div class="map-fix-dec">筛选</div>
          </div>
          <div class="map-fix-btn-center" @click="startDraw">
            <img class="map-fix-icon" src="../../assets/img/draw.png">
            <div class="map-fix-dec">画圈选</div>
          </div>
        </div>
      </transition>
      <transition>
        <div
          v-if="hiddenLabel&&!isInDrawing&&!openMore&&!openAttentionState"
          class="map-fix-btn2 list-position"
        >
          <div class="map-fix-btn-top" @click.stop="openList">
            <img class="map-fix-icon" src="../../assets/img/list.png">
            <div class="map-fix-dec">列表</div>
          </div>
          <div class="map-fix-btn-center" @click.stop="goVillageZoom">
            <img class="map-fix-icon" src="../../assets/img/village.png">
            <div class="map-fix-dec">{{isVillage?'商圈':'小区'}}</div>
          </div>
          <div class="map-fix-btn-bottom" @click.stop="openMoreBtn">
            <img class="map-fix-icon" src="../../assets/img/more.png">
            <div class="map-fix-dec">更多</div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="map-fix-btn location-position"
      v-if="!isInDrawing&&!openAttentionState"
      @click.stop="moveToLocation"
    >
      <img class="map-fix-icon" src="../../assets/img/location_fix.png">
      <div class="map-fix-dec">定位</div>
    </div>
    <div class="transition2">
      <transition>
        <swiper
          :options="swiperOption"
          v-if="hiddenLabel&&!isInDrawing&&!openAttentionState"
          class="map-fix-footer" 
        >
          <swiper-slide>
            <div class="map-fix-footer-content" v-debounce="goPrice">
              <img class="map-fix-price-img" src="../../assets/img/hxz_icon.png">
              <div class="map-fix-footer-text">
                <span>精打细算会定价，不再跟着感觉走</span>
              </div>
              <button class="map-fix-footer-btn">会定价</button>
            </div>
          </swiper-slide>
          <swiper-slide v-if="selectCityName=='南京'||currentCityName=='南京'">
            <div class="map-fix-footer-content" v-debounce="goSmallHouse">
              <img class="map-fix-footer-img" src="../../assets/img/small_house.png">
              <div class="map-fix-footer-text">
                <span>苦恼收不到房？最好用的收房小程序</span>
              </div>
              <button class="map-fix-footer-btn">小房子</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="map-fix-footer-content" v-debounce="goTrent">
              <img class="map-fix-footer-img" src="../../assets/img/trend.png">
              <div class="map-fix-footer-text" v-if="!isVillage">
                <span>{{score.name}}，全市商圈综合得分</span>
                <span style="color:#F5670B;font-weight:bold;">{{score.value}}分</span>
              </div>
              <div class="map-fix-footer-text" v-if="isVillage">
                <span>{{score.name}}，全市小区综合得分</span>
                <span style="color:#F5670B;font-weight:bold;">{{score.value}}分</span>
              </div>
              <button class="map-fix-footer-btn">看趋势</button>
            </div>
          </swiper-slide>
          
          <swiper-slide>
            <div class="map-fix-footer-content" v-debounce="goComplaints">
              <img class="map-fix-footer-img" src="../../assets/img/tucao.png">
              <div class="map-fix-footer-text">
                <span>说出您对我们的期望，不吐不快</span>
              </div>
              <button class="map-fix-footer-btn" style="backgroundColor:#F5A623;">去吐槽</button>
            </div>
          </swiper-slide>
        </swiper>
      </transition>
      <div class="map-fix-btn close-position" v-if="isInDrawing" @click.stop="closeDraw">
        <div class="map-fix-dec">退出</div>
      </div>
      <div
        class="map-fix-btn close-position"
        v-if="openAttentionState"
        @click.stop="closeAttentionState"
      >
        <div class="map-fix-dec">退出</div>
      </div>
      <div
        class="map-fix-btn3 analysis-position"
        v-if="finishDraw&&isInDrawing"
        @click.stop="goAnalysis"
      >
        <div class="map-fix-words">区域分析 ></div>
      </div>
      <div
        class="map-fix-btn reset-position"
        v-if="finishDraw&&isInDrawing"
        @click.stop="resetDraw"
      >
        <div class="map-fix-dec">重画</div>
      </div>
      <div class="open-more" v-if="openMore" @click="closeMore">
        <div class="more-box">
          <div class="more-item">
            <div class="more-fix-btn" v-debounce="openAttention">
              <img class="map-fix-icon" src="../../assets/img/attention.png">
            </div>
            <div class="more-fix-dec">我的关注</div>
          </div>
          <div class="more-item">
            <div class="more-fix-btn" v-debounce="openHistory">
              <img class="map-fix-icon" src="../../assets/img/history.png">
            </div>
            <div class="more-fix-dec">浏览历史</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timestampStart, timestampEnd;
let timer = '';
var map;
import { Dialog, Toast } from "vant";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "hxz",
  components: {
    Dialog,
    swiper,
    swiperSlide
  },
  data() {
    return {
      markers: [],
      polygons: [], //描点列表
      hiddenLabel: true,
      currentCityName: "定位中",
      currentCityId: 30,
      selectCityName: "",
      selectCityIndex: -1,
      cityId: 30,
      showDialog: false,
      score: {},
      clientHeight: 0,
      latitude: 39.915,
      longitude: 116.404,
      showGuide: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10
      },
      onlyOne: false,
      userId: '',
      noOpenDeatil: true,
      isInDrawing: false, //是否处于画圈状态下
      isMouseDown: false, //是否处于鼠标左键按下状态下
      polyPointArray: [], //存储画出折线点的数组
      lastPolyLine: '', //上次操作画出的折线
      polygonAfterDraw: [], //画圈完成后生成的多边形
      finishDraw: false, //画完状态
      isVillage: false, //是否是小区模式
      openMore: false, //更多
      openAttentionState: false, //关注模式
      openHistoryState:false,
      hasCellInDraw:false,
      noCell:false,
      showCollection:false
    };
  },
  directives: {
    debounce: {
      inserted: function(el, binding) {
        let timer;
        el.addEventListener("click", () => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            binding.value();
          }, 500);
        });
      }
    }
  },
  created() {
    console.log('参数配置---->', this.$route.query)
    let options = this.$route.query;
    console.log('options--->', options)
    if (options.showGuide && options.showGuide === 'true') {
      this.showGuide = true;
      this.isMiniProgram(res=>{
        if (res) {
          this.showCollection = true;
        }
      })
    }
    if (options.userId) {
      this.userId = options.userId;
      localStorage.setItem("userId", options.userId);
    }else{
      localStorage.removeItem("userId");
    }
    if (options.currentCityName) {
      localStorage.setItem("userInfoOrLocation", JSON.stringify(options));
    }
    timestampStart = (new Date()).getTime();
    let hrefStr = window.location.href;
    let hrefArr = hrefStr.split('?')[1]
    if (hrefArr&&hrefArr.slice(0,5)=='phone') {
      hrefArr = hrefArr.slice(6,17)
      this.$axios
      // .post("https://market.staging2.hzfapi.com/market/user/qftlogin/", {
      .post("https://market.huizhaofang.com/market/user/qftlogin/", {
        tel:hrefArr
      })
      .then(res => {
        if (res.success) {
          localStorage.setItem("userId", res.result.userId);
          this.addBuried({
            source:'1',
            eventType: '曝光事件',
            eventContent: '首页'
          });
        }
      })
      .catch(err => {
      });
    }else{
      this.addBuried({
        source:'1',
        eventType: '曝光事件',
        eventContent: '首页'
      });
    }
    this.isMiniProgram(res => {
      if (res) {
        if (options.isFirst==1) {
          localStorage.removeItem("screen");
          localStorage.removeItem("city");
          localStorage.removeItem("selectCityIndex");
        }
      }else{
        if (this._uid == 2) {
          localStorage.removeItem("screen");
          localStorage.removeItem("city");
          localStorage.removeItem("selectCityIndex");
        }
      }
    })
    this.clientHeight = document.documentElement.clientHeight + "px";
  },
  mounted() {
    map = new BMap.Map("container", {
      minZoom: 10,
      maxZoom: 19,
      enableMapClick: false,
      enableHighResolution: true
    });
    var point = new BMap.Point(116.404, 39.915);
    map.centerAndZoom(point, 13);
    map.disableContinuousZoom(); //禁用连续缩放效果
    map.highResolutionEnabled(true); //高分辨率
    this.getPointScore();
    let options = this.$route.query;
    this.isMiniProgram(res => {
      if (res) {
        if (options.sharePath=='area_detail') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/area_detail/index?cityId=" +
              options.cityId +
              "&zoneId=" +
              options.zoneId +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude
          });
        }else if (options.sharePath=='area_contrast') {
          wx.miniProgram.navigateTo({
            url:"/pages/area_contrast/index"
          });
        }else if (options.sharePath=='area_list') {
          wx.miniProgram.navigateTo({
            url:"/pages/area_list/index?cityId=" + options.cityId
          });
        }else if (options.sharePath=='business_trend') {
          wx.miniProgram.navigateTo({
            url:"/pages/business_trend/index?cityId=" + options.cityId
          });
        }else if (options.sharePath=='cell_detail') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/cell_detail/index?cityId=" +
              options.cityId +
              "&zoneId=" +
              options.zoneId +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude
          });
        }else if (options.sharePath=='cell_list') {
          wx.miniProgram.navigateTo({
            url:"/pages/cell_list/index?cityId=" + options.cityId
          });
        }else if (options.sharePath=='cell_market_price') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/cell_market_price/index?cityId=" +
              options.cityId +
              "&zoneId=" +
              options.zoneId +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude
          });
        }else if (options.sharePath=='cell_trend') {
          wx.miniProgram.navigateTo({
            url:"/pages/cell_trend/index?cityId=" + options.cityId
          });
        }else if (options.sharePath=='company_details') {
          wx.miniProgram.navigateTo({
            url:"/pages/company_details/index?zoneId=" + options.zoneId
          });
        }else if (options.sharePath=='draw_company_details') {
          wx.miniProgram.navigateTo({
            url:"/pages/draw_company_details/index?polyline=" + options.polyline
          });
        }else if (options.sharePath=='draw_market_price') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/draw_market_price/index?cityId=" +
              options.cityId +
              "&communityIds=" +
              options.communityIds +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude
          });
        }else if (options.sharePath=='draw_traffic_matching') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/draw_traffic_matching/index?cityId=" +
              options.cityId +
              "&polyline=" +
              options.polyline +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude +
              "&currentIndex=" +
              options.currentIndex +
              "&name=" +
              options.name
          });
        }else if (options.sharePath=='draw_village_list') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/draw_village_list/index?cityId=" +
              options.cityId +
              "&communityIds=" +
              options.communityIds
          });
        }else if (options.sharePath=='market_price') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/market_price/index?cityId=" +
              options.cityId +
              "&zoneId=" +
              options.zoneId +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude
          });
        }else if (options.sharePath=='region_detail') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/region_detail/index?cityId=" +
              options.cityId +
              "&polyline=" +
              options.polyline +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude +
              "&bizNames=" +
              options.bizNames +
              "&communityIds=" +
              options.communityIds
          });
        }else if (options.sharePath=='traffic_matching') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/traffic_matching/index?name=" +
              options.name +
              "&zoneId=" +
              options.zoneId +
              "&latitude=" +
              options.latitude +
              "&longitude=" +
              options.longitude +
              "&isCell=" +
              options.isCell +
              "&currentIndex=" +
              options.currentIndex 
          });
        }else if (options.sharePath=='village_contrast') {
          wx.miniProgram.navigateTo({
            url:"/pages/village_contrast/index"
          });
        }else if (options.sharePath=='village_list') {
          wx.miniProgram.navigateTo({
            url:
              "/pages/village_list/index?cityId=" +
              options.cityId +
              "&zoneId=" +
              options.zoneId
          });
        }else if(options.sharePath=='historyPrice') {
          wx.miniProgram.navigateTo({
            url:"/pages/house_price/historyPrice/index?id=" + options.id 
          });
        }else if(options.sharePath=='houseIndex') {
          wx.miniProgram.navigateTo({
            url:"/pages/house_price/index/index"
          });
        }else if(options.isPrice==1) {
          console.log('走你！')
          wx.miniProgram.navigateTo({
            url:"/pages/house_price/index/index?isEdit="+options.isEdit +"&houseId="+options.houseId
          });
        }else if(options.sharePath=='roomPrice') {
          wx.miniProgram.navigateTo({
            url:"/pages/house_price/roomPrice/index?houseId="+ options.houseId +'&isShare=1'
          });
        }else if(options.sharePath=='makeCount') {
          wx.miniProgram.navigateTo({
            url:"/pages/house_price/makeCount/index?id="+options.id
          });
        }
      } 
    });
    //监听地图缩放等级变化
    map.addEventListener("zoomend", () => {
      if (this.isInDrawing) {
        return false;
      }
      map.clearOverlays();
      if (this.openAttentionState) {
        let type;
        if (this.openHistoryState) {
          //历史模式
          type = 2
        }else{
          //关注模式
          type = 1
        }
        if (this.isVillage) {
          this.getVillageScore(false, false, type);
        }else{
          this.getPointScore(false, type);
        }
      } else {
        if (map.getZoom() > 15) {
          this.isVillage = true;
          this.getVillageScore();
        } else {
          this.isVillage = false;
          this.getPointScore();
          if (map.getZoom() > 13) {
            this.getPolyline();
          }
        }
      }
    });
    let count = 0;
    //监听点击地图
    map.addEventListener("click", e => {
      if (this.isInDrawing) {
        return false;
      }
      count++;
      if (timer1) {
        clearTimeout(timer1);
      }
      var timer1 = setTimeout(() => {
        if (count == 1) {
          if (!this.onlyOne) {
            // this.hiddenLabel = !this.hiddenLabel;
          }
        }
        count = 0;
      }, 300);
    });
    //监听地图移动
    map.addEventListener("moveend", () => {
      if (this.isInDrawing) {
        return false;
      }
      map.clearOverlays();
      if (this.openAttentionState) {
        let type;
        if (this.openHistoryState) {
          type = 2
        }else{
          type = 1
        }
        if (this.isVillage) {
          this.getVillageScore(false, false, type);
        }else{
          this.getPointScore(false, type);
        }
      } else {
        if (map.getZoom() > 15) {
          this.getVillageScore();
        } else {
          this.getPointScore();
          if (map.getZoom() > 13) {
            this.getPolyline();
          }
        }
      }
    });
    map.addEventListener("touchstart", e => {
      if (this.finishDraw) {
        return false;
      }
      map.removeOverlay(this.polygonAfterDraw);
      this.isMouseDown = true;
    });
    map.addEventListener("touchmove", e => {
      this.noOpenDeatil = false;
      if (this.finishDraw) {
        return false;
      }
      //如果处于鼠标按下状态,才能进行画操作
      if (this.isMouseDown && this.isInDrawing) {
        this.addBuried({
          source: "1",
          eventType: "点击事件",
          eventContent: "画圈行为"
        });
        //将鼠标移动过程中采集到的路径点加入数组保存
        this.polyPointArray.push(e.point);
        //除去上次的画线
        // if (this.lastPolyLine) {
        //   map.removeOverlay(this.lastPolyLine);
        // }
        //根据已有的路径数组构建画出的折线
        var polylineOverlay = new window.BMap.Polyline(this.polyPointArray, {
          strokeColor: "#F5A623",
          strokeOpacity: 1,
          enableClicking: false
        });
        //添加新的画线到地图上
        map.addOverlay(polylineOverlay);
        //更新上次画线条
        this.lastPolyLine = polylineOverlay;
      } else {
        map.enableDragging();
      }
    });
    // TODO: 触摸结束时触发次此事件  此时开启禁止拖动
    map.addEventListener("touchend", e => {
      this.noOpenDeatil = true;
      if (this.finishDraw) {
        return false;
      }
      //如果处于画圈状态下 且 鼠标是按下状态
      if (this.isMouseDown && this.isInDrawing) {
        //退出画线状态
        // this.isMouseDown = false;
        // this.isInDrawing = false;
        //添加多边形覆盖物,设置为禁止点击
        var polygon = new window.BMap.Polygon(this.polyPointArray, {
          strokeColor: "#F5A623",
          strokeOpacity: 1,
          fillColor: "#F5A623",
          fillOpacity: 0.3,
          enableClicking: false
        });
        map.addOverlay(polygon);
        //保存多边形,用于后续删除该多边形
        this.polygonAfterDraw = polygon;
        this.finishDraw = true;
        let polygonArr = polygon.so;
        let polygonLen = polygonArr.length;
        let distance = 0;
        let seDistance = map.getDistance(
          polygonArr[0],
          polygonArr[polygonLen - 1]
        );
        if (polygonLen < 3 || polygon.getBounds().isEmpty()) {
          Toast("一个点无法形成闭环哦");
          this.resetDraw();
        } else {
          for (let i = 0; i < polygonLen - 1; i++) {
            distance =
              distance +
              Number(map.getDistance(polygonArr[i], polygonArr[i + 1]));
          }
          if (distance - seDistance > 10) {
            Toast("画圈成功");
            if (polygon.getBounds().toSpan().lat > 0.005) {
              map.centerAndZoom(polygon.getBounds().getCenter(), 16);
            } else if (
              polygon.getBounds().toSpan().lat > 0.0025 &&
              polygon.getBounds().toSpan().lat < 0.005
            ) {
              map.centerAndZoom(polygon.getBounds().getCenter(), 17);
            } else {
              map.centerAndZoom(polygon.getBounds().getCenter(), 18);
            }
            map.enableDragging();
            map.enableScrollWheelZoom();
            map.enableDoubleClickZoom();
            map.enableKeyboard();
            map.setDefaultCursor("default");
            this.hasCellInDraw = true;
            this.getVillageScore(
              polygon.getBounds().getSouthWest(),
              polygon.getBounds().getNorthEast()
            );
          } else {
            Toast("一条线无法形成闭环哦");
            this.resetDraw();
          }
        }
      } else {
        map.disableDragging();
      }
    });
    let screenData = JSON.parse(localStorage.getItem("screen"));
    let cityData = JSON.parse(localStorage.getItem("city"));
    if (screenData) {
      if (screenData.isCell) {
        map.setZoom(17);
      }
      let currentCity = JSON.parse(localStorage.getItem("currentCity"));
      if (currentCity && currentCity.currentCityName && this.selectCityName != currentCity.currentCityName) {
        this.getScreen(screenData);
      } else {
        this.isMiniProgram(res => {
          if (res) {
            // let currentCity = JSON.parse(localStorage.getItem("currentCity"));
            // this.currentCityName = currentCity.currentCityName;
            // this.cityId = currentCity.currentCityId;
            // this.getZoneAvgScore(this.cityId);
            this.getLocation(true);
          } else {
            this.getLocation(true);
          }
        });
        this.getScreen(screenData);
      }
    } else if (cityData) {
      this.saveCity(cityData);
    } else {
      if (!this.openAttentionState) {
        if (map.getZoom() > 15) {
          this.getVillageScore();
        } else {
          this.getPointScore(true);
        }
      }
      this.getLocation();
    }
    setTimeout(() => {
      this.getPointScore();
    }, 500)
  },
  methods: {
    //开始画圈
    startDraw() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "画圈"
      });
      if (map.getZoom() <= 15) {
        Toast("放大地图到小区级别后，才能使用画圈选址哦～");
        return false;
      }
      map.clearOverlays();
      //禁止地图移动点击等操作
      map.disableDragging();
      map.disableScrollWheelZoom();
      map.disableDoubleClickZoom();
      map.disableKeyboard();
      map.setDefaultCursor("crosshair");
      document.getElementById('page').addEventListener('touchmove', function(e) {
        e.preventDefault();
      })
      //设置标志位进入画圈状态
      this.isInDrawing = true;
      this.finishDraw = false;
      this.polygonAfterDraw = [];
      this.polyPointArray = [];
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.postMessage({ data: { hiddenShare: true }})
        }
      })
    },
    //退出画圈
    closeDraw() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "退出画圈"
      });
      map.clearOverlays();
      if (map.getZoom() > 15) {
        this.getVillageScore();
      } else {
        this.getPointScore();
        if (map.getZoom() > 13) {
          this.getPolyline();
        }
      }
      //恢复地图移动点击等操作
      map.enableDragging();
      map.enableScrollWheelZoom();
      map.enableDoubleClickZoom();
      map.enableKeyboard();
      map.setDefaultCursor("default");
      map.setZoom(16);
      //设置标志位退出画圈状态
      this.isInDrawing = false;
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.postMessage({ data: { showShare: true }})
        }
      })
    },
    //重画
    resetDraw() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "重画"
      });
      map.clearOverlays();
      this.finishDraw = false;
      this.polygonAfterDraw = [];
      this.polyPointArray = [];
      map.setZoom(16);
      map.disableDragging();
      map.disableScrollWheelZoom();
      map.disableDoubleClickZoom();
      map.disableKeyboard();
      map.setDefaultCursor("crosshair");
    },
    //区域分析
    goAnalysis() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "画圈区域分析"
      });
      if (this.noCell) {
        return false
      }
      let pointList = this.polyPointArray;
      localStorage.setItem("drawList", JSON.stringify(pointList));
      let centerPoint = this.polygonAfterDraw.getBounds().getCenter();
      let pointLen = pointList.length;
      let polyline = [];
      for (let i = 0; i < pointLen; i++) {
        polyline.push(pointList[i].lng + "," + pointList[i].lat);
      }
      let pointStr = polyline.join(";");
      let bssw = this.polygonAfterDraw.getBounds().getSouthWest(); //画圈区域左下角
      let bsne = this.polygonAfterDraw.getBounds().getNorthEast(); //画圈区域右上角
      this.$axios
        .post("api/xz/draw/", {
          polyline: pointStr,
          maxLatitude: bsne.lat,
          maxLongitude: bsne.lng,
          minLatitude: bssw.lat,
          minLongitude: bssw.lng,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            let communityIds = res.result.communityIds;
            let bizNames = res.result.bizNames;
            if (JSON.stringify(res.result)==='{}') {
              Toast('画圈未包含小区，请重新画圈')
              return false
            }
            this.isMiniProgram(res => {
              if (res) {
                wx.miniProgram.navigateTo({
                  url:
                    "/pages/region_detail/index?cityId=" +
                    this.cityId +
                    "&polyline=" +
                    pointStr +
                    "&bizNames=" +
                    bizNames +
                    "&communityIds=" +
                    communityIds +
                    "&latitude=" +
                    centerPoint.lat +
                    "&longitude=" +
                    centerPoint.lng
                });
              } else {
                this.$router.push({
                  path: "/region_detail",
                  query: {
                    cityId: this.cityId,
                    polyline: pointStr,
                    communityIds: communityIds,
                    bizNames: bizNames,
                    latitude: centerPoint.lat,
                    longitude: centerPoint.lng
                  }
                });
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //列表模式
    openList() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "列表模式"
      });
      if (map.getZoom() >= 16) {
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url: "/pages/cell_list/index?cityId=" + this.cityId
            });
          } else {
            this.$router.push({
              path: "/cell_list",
              query: { cityId: this.cityId }
            });
          }
        });
      } else {
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url: "/pages/area_list/index?cityId=" + this.cityId
            });
          } else {
            this.$router.push({
              path: "/area_list",
              query: { cityId: this.cityId }
            });
          }
        });
      }
    },
    //去小区模式
    goVillageZoom() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "商圈小区切换"
      });
      if (map.getZoom() >= 16) {
        map.setZoom(13);
        this.isVillage = true;
      } else {
        map.setZoom(16);
        this.isVillage = false;
      }
      this.getZoneAvgScore(this.cityId);
    },
    //打开更多
    openMoreBtn() {
      this.openMore = true;
    },
    //关闭更多
    closeMore() {
      this.openMore = false;
    },
    //打开关注
    openAttention() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "关注"
      });
      let userId = localStorage.getItem('userId');
      if (!userId||userId=='undefined') {
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.redirectTo({
              url: "/pages/login/index?from=home"
            });
          } else {
           
          }
        });
      }else{
        this.userId = userId
        this.openMore = false;
        this.openAttentionState = true;
        map.clearOverlays();
        if (map.getZoom() > 15) {
          this.isVillage = true;
          this.getVillageScore(false, false, 1);
        } else {
          this.isVillage = false;
          this.getPointScore(false, 1);
          if (map.getZoom() > 13) {
            this.getPolyline();
          }
        }
      }
    },
    //退出关注模式
    closeAttentionState() {
      this.openAttentionState = false;
      this.openHistoryState = false;
      map.clearOverlays();
      if (map.getZoom() > 15) {
        this.getVillageScore();
      } else {
        this.getPointScore();
        if (map.getZoom() > 13) {
          this.getPolyline();
        }
      }
    },
    //打开历史
    openHistory() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "浏览历史"
      });
      let userId = localStorage.getItem('userId');
      if (!userId||userId=='undefined') {
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.redirectTo({
              url: "/pages/login/index?from=home"
            });
          } else {
           
          }
        });
      }else{
        this.userId = userId
        this.openMore = false;
        this.openAttentionState = true;
        this.openHistoryState = true;
        map.clearOverlays();
        if (map.getZoom() > 15) {
          this.isVillage = true;
          this.getVillageScore(false, false, 2);
        } else {
          this.isVillage = false;
          this.getPointScore(false, 2);
          if (map.getZoom() > 13) {
            this.getPolyline();
          }
        }
      }
    },
    //关闭引导
    closeGuide() {
      this.showGuide = false;
    },
    //关闭collection引导
    closeCollection(){
      this.showCollection = false;
    },
    getLocation(noFirst) {
      let self = this;
      let myIcon = new BMap.Icon(
        require("../../assets/img/current_location.png"),
        new BMap.Size(18, 31)
      );
      this.isMiniProgram(res => {
        if (res) {
          let options =JSON.parse(localStorage.getItem('userInfoOrLocation')); 
          self.currentCityName = options.currentCityName;
          console.log(options.isSuccess)
          if (options.isSuccess == 0) {
            console.log(options.currentCityName)
            localStorage.setItem(
              "currentCity",
              JSON.stringify({
                currentCityId: self.cityId,
                currentCityName: options.currentCityName,
                latitude: self.latitude,
                longitude: self.longitude
              })
            );
            this.getZoneAvgScore(self.cityId);
          } else {
            let point = {
              lng: Number(options.longitude),
              lat: Number(options.latitude)
            };
            var mk = new BMap.Marker(point, { icon: myIcon });
            mk.disableMassClear();
            map.addOverlay(mk);
            if (!noFirst) {
              map.panTo(new BMap.Point(options.longitude, options.latitude));
            }
            self.getCurrentCityId(
              options.currentCityName,
              options.latitude,
              options.longitude
            );
          }
        } else {
          var geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition(function(r) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              self.latitude = r.point.lat;
              self.longitude = r.point.lng;
              var mk = new BMap.Marker(r.point, { icon: myIcon });
              mk.disableMassClear();
              map.addOverlay(mk);
              if (!noFirst) {
                map.panTo(r.point);
              }
              let str = r.address.city;
              self.currentCityName = str.substring(0, str.length - 1);
              self.getCurrentCityId(
                self.currentCityName,
                self.latitude,
                self.longitude
              );
            } else {
              self.currentCityName = "北京";
              self.cityId = 30;
              localStorage.setItem(
                "currentCity",
                JSON.stringify({
                  currentCityId: self.cityId,
                  currentCityName: self.currentCityName,
                  latitude: self.latitude,
                  longitude: self.longitude
                })
              );
              this.getZoneAvgScore(self.cityId);
            }
          });
        }
      });
    },
    //获取当前定位城市cityId
    getCurrentCityId(currentCityName, latitude, longitude) {
      this.$axios
        .post("api/xz/city/list/")
        .then(res => {
          if (res.success) {
            this.cities = res.result;
            for (let i = 0; i < this.cities.length; i++) {
              if (this.cities[i].name == this.currentCityName) {
                this.cityId = this.cities[i].value;
                this.currentCityId = this.cities[i].value;
                localStorage.setItem(
                  "currentCity",
                  JSON.stringify({
                    currentCityId: this.cities[i].value,
                    currentCityName: currentCityName,
                    latitude: latitude,
                    longitude: longitude
                  })
                );
              }
            }
            this.getZoneAvgScore(this.currentCityId);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCityName(cityId) {
      this.$axios
        .post("api/xz/city/list/")
        .then(res => {
          if (res.success) {
            this.cities = res.result;
            for (let i = 0; i < this.cities.length; i++) {
              if (this.cities[i].value == cityId) {
                this.selectCityName = this.cities[i].name;
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //城市选择页回调数据
    saveCity(data) {
      this.selectCityName = data.item.name;
      this.selectCityIndex = data.currentIndex;
      localStorage.setItem(
        "selectCityIndex",
        JSON.stringify(data.currentIndex)
      );
      this.cityId = data.item.value;
      this.getZoneAvgScore(this.cityId);
      map.panTo(new BMap.Point(data.item.longitude, data.item.latitude));
      this.getPointScore();
      // this.isMiniProgram(res => {
      //   if (res) {
      // localStorage.removeItem('city');
      //   }
      // });
    },
    //筛选页回调数据
    getScreen(data) {
      this.getCityName(data.cityId);
      map.panTo(new BMap.Point(data.longitude, data.latitude));
      this.cityId = data.cityId;
      this.getZoneAvgScore(this.cityId);
      if (data.isCell) {
        this.getVillageScore();
      } else {
        this.getPointScore();
      }
      // this.isMiniProgram(res => {
      //   if (res) {
      //     localStorage.removeItem('screen');
      //   }
      // });
    },
    //跳转筛选
    screenTradingArea() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "筛选"
      });
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url: "/pages/screen/index?cityId=" + this.cityId
          });
        } else {
          this.$router.push({
            path: "/screen",
            query: { cityId: this.cityId }
          });
        }
      });
    },
    goSearch() {
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url: "/pages/search/index?cityId=" + this.cityId
          });
        } else {
          this.$router.push({
            path: "/search",
            query: { cityId: this.cityId }
          });
        }
      });
    },
    goCitySelect() {
      localStorage.removeItem("screen");
      let currentCity = JSON.parse(localStorage.getItem("currentCity"));
      let selectCityIndex = JSON.parse(localStorage.getItem("selectCityIndex"));
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:
              "/pages/select_city/index?currentCityName=" +
              currentCity.currentCityName +
              "&selectCityIndex=" +
              selectCityIndex +"&type=0"
          });
        } else {
          this.$router.push({
            path: "/select_city",
            query: {
              currentCityName: currentCity.currentCityName,
              selectCityIndex: selectCityIndex,
              type:0
            }
          });
        }
      });
    },
    //跳转吐槽
    goComplaints(e) {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "去吐槽"
      });
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url: "/pages/make_complaints/index?cityId=" + this.cityId
          });
        } else {
          this.$router.push({
            path: "/make_complaints",
            query: { cityId: this.cityId }
          });
        }
      });
    },
    //去房子
    goSmallHouse() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "小房子"
      });
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url: "/pages/navigation_center/index"
          });
        } else {
        }
      });
    },
    //跳转商圈趋势
    goTrent(e) {
      if (map.getZoom() >= 16) {
        this.addBuried({
          source: "1",
          eventType: "点击事件",
          eventContent: "看趋势-商圈"
        });
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url: "/pages/cell_trend/index?cityId=" + this.cityId
            });
          } else {
            this.$router.push({
              path: "/cell_trend",
              query: { cityId: this.cityId }
            });
          }
        });
      } else {
        this.addBuried({
          source: "1",
          eventType: "点击事件",
          eventContent: "看趋势-小区"
        });
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url: "/pages/business_trend/index?cityId=" + this.cityId
            });
          } else {
            this.$router.push({
              path: "/business_trend",
              query: { cityId: this.cityId }
            });
          }
        });
      }
    },
    goPrice() {
      this.isMiniProgram(res => {
        if (res) {
           wx.miniProgram.navigateTo({
              url: "/pages/house_price/index/index"
            });
        }
      });
    },
    //移动到定位地点
    moveToLocation() {
      let myIcon = new BMap.Icon(
        require("../../assets/img/current_location.png"),
        new BMap.Size(18, 31)
      );
      let currentCity = JSON.parse(localStorage.getItem("currentCity"));
      if (!this.selectCityName) {
        this.selectCityName = currentCity.currentCityName;
      }
      if (currentCity.currentCityName == this.selectCityName) {
        let mk = new BMap.Marker(
          new BMap.Point(currentCity.longitude, currentCity.latitude),
          { icon: myIcon }
        );
        mk.disableMassClear();
        map.addOverlay(mk);
        map.panTo(new BMap.Point(currentCity.longitude, currentCity.latitude));
        localStorage.removeItem("screen");
      } else {
        Dialog.confirm({
          title: "提示",
          message: "是否切换城市"
        }).then(() => {
          this.selectCityName = currentCity.currentCityName;
          this.selectCityIndex = -1;
          //当前定位城市id
          this.cityId = currentCity.currentCityId;
          this.getZoneAvgScore(currentCity.currentCityId);
          let mk = new BMap.Marker(
            new BMap.Point(currentCity.longitude, currentCity.latitude),
            { icon: myIcon }
          );
          mk.disableMassClear();
          map.addOverlay(mk);
          map.panTo(
            new BMap.Point(currentCity.longitude, currentCity.latitude)
          );
          localStorage.removeItem("city");
          localStorage.removeItem("selectCityIndex");
        });
      }
    },
    //商圈/小区平均得分
    getZoneAvgScore(cityId) {
      let param = {
        cityId: cityId
      };
      let url;
      if (map.getZoom() >= 16) {
        url="api/xz/score/avg/community/"
      }else{
        url="api/xz/score/avg/"
      }
      this.$axios
        .post(url, param)
        .then(res => {
          if (res.success) {
            this.score = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取商圈得分信息
    getPointScore(first, type) {
      const toast1 = Toast.loading({
        // duration: 300, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      var bs = map.getBounds(); //获取可视区域
      var bssw = bs.getSouthWest(); //可视区域左下角
      var bsne = bs.getNorthEast(); //可视区域右上角
      let self = this;
      let param;
      if (first) {
        param = {
          maxLatitude: 39.988785,
          maxLongitude: 116.457898,
          minLatitude: 39.841135,
          minLongitude: 116.350102,
          cityId: self.cityId,
          userId:self.userId
        };
      } else {
        param = {
          maxLatitude: bsne.lat,
          maxLongitude: bsne.lng,
          minLatitude: bssw.lat,
          minLongitude: bssw.lng,
          cityId: self.cityId,
          type: type,
          userId: self.userId
        };
      }
      this.$axios
        .post("api/xz/visible/scores/", param)
        .then(res => {
          if (res.success) {
            let open = true;
            let mp = map;
            //定义自定义覆盖物的构造函数
            //1、定义构造函数并继承Overlay
            function ComplexCustomOverlay(point, title, score) {
              this._point = point;
              this._title = title;
              this._score = score;
            } // 继承API的BMap.Overlay
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            //2、初始化自定义覆盖物
            // 实现初始化方法
            ComplexCustomOverlay.prototype.initialize = function(map) {
              // this.se = false;//禁止清除marker
              // 保存map对象实例
              this._map = map;
              // 创建div元素，作为自定义覆盖物的容器
              var div = (this._div = document.createElement("div"));
              div.style.position = "absolute";
              // div.style.zIndex = BMap.Overlay.getZIndex(this._point.latitude);//聚合功能?
              // 可以根据参数设置元素外观
              var arrow = (this._arrow = document.createElement("img"));
              let img = require("../../assets/img/score_bg.png");
              // "http://img-set.oss-cn-beijing.aliyuncs.com/score?Expires=1554292145&OSSAccessKeyId=TMP.AQEuNork9JZT4SzPmx7q4OC9WbgrDekvEkhlIB83fwneKk9WbJ-_j6fTXKvFAAAwLAIUS0LsBtOGKADVwGQXkk9u15q0TD8CFGJL9Qeum-3LNzVnU4gsbkRn7iuG&Signature=UI8rDap3xUZcE4Nr97CdDJrX6fY%3D";
              arrow.src = img;
              arrow.style.width = "60px";
              arrow.style.height = "65px";
              div.appendChild(arrow);
              var div1 = (this._div1 = document.createElement("div"));
              div1.style.color = "#fff";
              div1.style.fontSize = "13px";
              div1.style.textAlign = "center";
              div1.style.width = "60px";
              div1.style.position = "absolute";
              div1.style.left = "0";
              if (this._title.length > 4) {
                div1.style.top = "5px";
                div1.innerHTML = this._title.slice(0, 3);
                div.appendChild(div1);
                var div3 = (this._div3 = document.createElement("div"));
                div3.style.color = "#fff";
                div3.style.fontSize = "13px";
                div3.style.textAlign = "center";
                div3.style.width = "60px";
                div3.style.position = "absolute";
                div3.style.top = "20px";
                div3.style.left = "0";
                div3.innerHTML = this._title.slice(3, this._title.length);
                div.appendChild(div3);
              } else {
                div1.style.top = "12px";
                div1.innerHTML = this._title;
                div.appendChild(div1);
              }
              var div2 = (this._div2 = document.createElement("div"));
              div2.style.color = "#fff";
              div2.style.fontSize = "13px";
              div2.style.textAlign = "center";
              div2.style.width = "60px";
              div2.style.fontWeight = "bold";
              div2.style.position = "absolute";
              if (this._title.length > 4) {
                div2.style.top = "35px";
              } else {
                div2.style.top = "28px";
              }
              div2.style.left = "0";
              div2.innerHTML = this._score + "分";
              div.appendChild(div2); // 将div添加到覆盖物容器中
              mp.getPanes().labelPane.appendChild(div); //getPanes(),返回值:MapPane,返回地图覆盖物容器列表  labelPane呢???
              // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
              // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
              return div;
            };
            //3、绘制覆盖物
            // 实现绘制方法
            ComplexCustomOverlay.prototype.draw = function() {
              var map = this._map;
              var pixel = map.pointToOverlayPixel(this._point);
              this._div.style.left = pixel.x + "px";
              this._div.style.top = pixel.y - 30 + "px";
            };
            //4、自定义覆盖物添加事件方法
            ComplexCustomOverlay.prototype.addEventListener = function(
              event,
              fun
            ) {
              this._div["on" + event] = fun;
            };
            let scoreList = res.result;
            if (scoreList.length==0) {
              if (self.openAttentionState) {
                if (self.openHistoryState) {
                  Toast('暂无浏览历史')
                }else{
                  Toast('暂无关注商圈')
                }
              }
              self.openAttentionState = false;
            }
            let scoreLen = scoreList.length;
            for (let i = 0; i < scoreLen; i++) {
              var myCompOverlay = new ComplexCustomOverlay(
                new BMap.Point(scoreList[i].longitude, scoreList[i].latitude),
                scoreList[i].zoneName,
                scoreList[i].score
              );
              mp.addOverlay(myCompOverlay); //将标注添加到地图中
              toast1.clear();
              //5、 为自定义覆盖物添加点击事件
              let timer;
              myCompOverlay.addEventListener("touchend", function(e) {
                self.onlyOne = true;
                if (!self.noOpenDeatil) {
                  return false;
                }
                mp.addEventListener("click", function(e) {
                  console.log('点击覆盖物', e)
                  console.log('timer---->', timer)
                  if (timer) {
                    clearTimeout(timer);
                  }
                  timer = setTimeout(() => {
                    if (open) {
                      self.onlyOne = false;
                      self.isMiniProgram(res => {
                        if (res) {
                          let type;
                          if (self.openAttentionState) {
                            if (self.openHistoryState) {
                              type = 2
                            }else{
                              type = 1
                            }
                            self.getPointScore(false,type);
                          }else{
                            self.getPointScore();
                          }
                          wx.miniProgram.navigateTo({
                            url:
                              "/pages/area_detail/index?cityId=" +
                              self.cityId +
                              "&zoneId=" +
                              scoreList[i].zoneId +
                              "&latitude=" +
                              scoreList[i].latitude +
                              "&longitude=" +
                              scoreList[i].longitude
                          });
                        } else {
                          self.$router.push({
                            path: "/area_detail",
                            query: {
                              cityId: self.cityId,
                              zoneId: scoreList[i].zoneId,
                              latitude: scoreList[i].latitude,
                              longitude: scoreList[i].longitude
                            }
                          });
                        }
                        open = false;
                      });
                    }
                  },300);
                });
              });
            }
          }
        })
        .catch(err => {
          toast1.clear();
          console.log(err);
        });
    },
    //获取商圈描边信息
    getPolyline() {
      const toast2 = Toast.loading({
        duration: 300, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      var bs = map.getBounds(); //获取可视区域
      var bssw = bs.getSouthWest(); //可视区域左下角
      var bsne = bs.getNorthEast(); //可视区域右上角
      let self = this;
      let param = {
        maxLatitude: bsne.lat,
        maxLongitude: bsne.lng,
        minLatitude: bssw.lat,
        minLongitude: bssw.lng,
        cityId: self.cityId
      };
      this.$axios
        .post("api/xz/visible/polyline/", param)
        .then(res => {
          if (res.success) {
            let coordinateList = res.result;
            let len = coordinateList.length;
            let arr;
            for (let i = 0; i < len; i++) {
              arr = [];
              for (let j = 0; j < coordinateList[i].length; j++) {
                arr.push(
                  new BMap.Point(
                    coordinateList[i][j].longitude,
                    coordinateList[i][j].latitude
                  )
                );
              }
              var polygon = new BMap.Polygon(arr, {
                strokeColor: "#4169E1",
                strokeStyle: "dashed",
                fillColor: "#4169E1",
                strokeWeight: 1.5,
                strokeOpacity: 1,
                fillOpacity: 0.1
              });
              map.addOverlay(polygon);
              toast2.clear();
            }
          }
        })
        .catch(err => {
          toast2.clear();
          console.log(err);
        });
    },
    //获取小区得分信息
    getVillageScore(bssw, bsne, type) {
      const toast1 = Toast.loading({
        // duration: 300, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      let self = this;
      let param;
      if (bssw) {
        param = {
          maxLatitude: bsne.lat,
          maxLongitude: bsne.lng,
          minLatitude: bssw.lat,
          minLongitude: bssw.lng,
          cityId: self.cityId,
          userId:self.userId
        };
      } else{
        var bs = map.getBounds(); //获取可视区域
        var bssw = bs.getSouthWest(); //可视区域左下角
        var bsne = bs.getNorthEast(); //可视区域右上角
        param = {
          maxLatitude: bsne.lat,
          maxLongitude: bsne.lng,
          minLatitude: bssw.lat,
          minLongitude: bssw.lng,
          cityId: self.cityId,
          type: type,
          userId:self.userId
        };
      }
      this.$axios
        .post("api/xz/visible/scores/community/", param)
        .then(res => {
          if (res.success) {
            if (self.hasCellInDraw) {
              if (JSON.stringify(res.result)=='{}') {
                Toast('画圈未包含小区，请重新画圈');
                self.noCell = true;
                return false;
              }else{
                self.noCell = false;
              }
            }
            let open = true;
            let mp = map;
            //定义自定义覆盖物的构造函数
            //1、定义构造函数并继承Overlay
            function ComplexCustomOverlay(point, title, score) {
              this._point = point;
              this._title = title;
              this._score = score;
            } // 继承API的BMap.Overlay
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            //2、初始化自定义覆盖物
            // 实现初始化方法
            ComplexCustomOverlay.prototype.initialize = function(map) {
              // this.se = false;//禁止清除marker
              // 保存map对象实例
              this._map = map;
              // 创建div元素，作为自定义覆盖物的容器
              var div = (this._div = document.createElement("div"));
              div.style.position = "absolute";
              div.style.color = "#fff";
              div.style.lineHeight = "28px";
              div.style.height = "28px";
              div.style.padding = "0 10px";
              div.style.whiteSpace = "nowrap";
              div.style.MozUserSelect = "none";
              div.style.fontSize = "13px";
              div.style.textAlign = "center";
              div.style.backgroundColor = "#4169E1";
              div.style.borderRadius = "14px";
              div.style.border = "1px solid #fff";
              var div1 = (this._div1 = document.createElement("span"));
              div1.innerHTML = this._title;
              div.appendChild(div1);
              var div2 = (this._div2 = document.createElement("span"));
              div2.style.fontWeight = "bold";
              div2.style.marginLeft = "4px";
              div2.innerHTML = this._score + "分";
              div.appendChild(div2); // 将div添加到覆盖物容器中
              mp.getPanes().labelPane.appendChild(div); //getPanes(),返回值:MapPane,返回地图覆盖物容器列表  labelPane呢???
              // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
              // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
              return div;
            };
            //3、绘制覆盖物
            // 实现绘制方法
            ComplexCustomOverlay.prototype.draw = function() {
              var map = this._map;
              var pixel = map.pointToOverlayPixel(this._point);
              this._div.style.left = pixel.x + "px";
              this._div.style.top = pixel.y - 30 + "px";
            };
            //4、自定义覆盖物添加事件方法
            ComplexCustomOverlay.prototype.addEventListener = function(
              event,
              fun
            ) {
              this._div["on" + event] = fun;
            };
            let scoreList = res.result;
            if (scoreList.length==0) {
              if (self.openAttentionState) {
                if (self.openHistoryState) {
                  Toast('暂无浏览历史')
                }else{
                  Toast('暂无关注小区')
                }
              }
              self.openAttentionState = false;
            }
            let scoreLen = scoreList.length;
            for (let i = 0; i < scoreLen; i++) {
              var myCompOverlay = new ComplexCustomOverlay(
                new BMap.Point(scoreList[i].longitude, scoreList[i].latitude),
                scoreList[i].zoneName,
                scoreList[i].score
              );
              mp.addOverlay(myCompOverlay); //将标注添加到地图中
              toast1.clear();
              //5、 为自定义覆盖物添加点击事件
              let timer;
              myCompOverlay.addEventListener("touchend", function(e) {
                self.onlyOne = true;
                if (!self.noOpenDeatil) {
                  return false;
                }
                mp.addEventListener("click", function(e) {
                  if (timer) {
                    clearTimeout(timer);
                  }
                  timer = setTimeout(() => {
                    if (open) {
                      self.onlyOne = false;
                      self.isMiniProgram(res => {
                        if (res) {
                          let type;
                          if (self.openAttentionState) {
                            if (self.openHistoryState) {
                              type = 2
                            }else{
                              type = 1
                            }
                            self.getVillageScore(false,false,type);
                          }else{
                            self.getVillageScore();
                          }
                          wx.miniProgram.navigateTo({
                            url:
                              "/pages/cell_detail/index?cityId=" +
                              self.cityId +
                              "&zoneId=" +
                              scoreList[i].zoneId +
                              "&latitude=" +
                              scoreList[i].latitude +
                              "&longitude=" +
                              scoreList[i].longitude
                          });
                        } else {
                          self.$router.push({
                            path: "/cell_detail",
                            query: {
                              cityId: self.cityId,
                              zoneId: scoreList[i].zoneId,
                              latitude: scoreList[i].latitude,
                              longitude: scoreList[i].longitude
                            }
                          });
                        }
                        open = false;
                      });
                    }
                  }, 500);
                });
              });
            }
          }
        })
        .catch(err => {
          toast1.clear();
          console.log(err);
        });
    }
  },
  destroyed() {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '首页停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/home/index.vue